import Views from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { meetInfoIsComplete } from './LeftNavValidation';

const getMeetInfo = (viewName, route, omeMeetOrgUnitEntryInfoStateObjData, omeMeetOrgUnitEntryRosterPermissionsStateObjData) => {
  const isCurrent = viewName === Views.OME_MEET_INFO_TEAM_ENTRY ? true : false;

  const isComplete = meetInfoIsComplete(omeMeetOrgUnitEntryInfoStateObjData, omeMeetOrgUnitEntryRosterPermissionsStateObjData);

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_INFO_TEAM_ENTRY) : getInitialStateMeetRoute(Views.OME_MEET_INFO_TEAM_ENTRY);

  return {
    ...item,
    isCurrent,
    isComplete
  };
};

export default getMeetInfo;